<template>
    <div>
        <form method="post" enctype="multipart/form-data" @submit.prevent="formSubmitted" class="form-check isJj" id="topOfForm">

        <div class="login-fieldset" :class="{isTpg:isTpg}">
            <div class="login-container" :class="{isTpg:isTpg,isTpg:useWhiteTheme}">
                <div class="alert alert-danger login-alert" v-if="error">
                    <p>{{ error }}</p>
                </div>

                <!-- Reset -->
                <div v-if="showResetForm">

                    <div class="alert alert-success login-alert" v-if="success">
                        <p>{{ success }}</p>
                    </div>

                    <h4 class="reset-header" :class="{isTpg:isTpg}">Enter email to reset your password</h4>
                    <div class="form-group" style="">
                        <input id="resetEmail"
                               type="email"
                               name="resetEmail"
                               v-model="resetEmail"
                               placeholder="Email Address"
                               class="login-form-text-field"
                               autocomplete="on"
                               :class="{isTpg:(isTpg || useWhiteTheme)}"
                               required
                               autofocus>
                    </div>
                    <div>
                        <button class="sign-in-button"
                                v-bind:class="{ 'sign-in-button-disabled': loading,isTpg:isTpg,isTpg:(isTpg || useWhiteTheme) }"
                                id="reset-password-submit"
                                @click="sendResetEmail()">
                            Submit
                        </button>
                    </div>
                    <div class="forgot-password" id="cancel-reset" :class="{isTpg:(isTpg || useWhiteTheme)}" @click="cancelReset" >
                        <a style="cursor:pointer;">Cancel</a>
                    </div>
                </div>

                <!-- Login -->
                <div v-else>
                <div class="login-text" :class="{isTpg:(isTpg || useWhiteTheme)}">Login</div>
                <div class="form-group">
                    <input id="email"
                           type="email"
                           name="email"
                           v-model="credentials.email"
                           placeholder="Email Address"
                           class="login-form-text-field"
                           autocomplete="on"
                           :class="{isTpg:(isTpg || useWhiteTheme)}"
                           required
                           autofocus>
                </div>
                <div class="form-group">
                    <input id="password"
                           type="password"
                           name="password"
                           placeholder="Password"
                           autocomplete="off"
                           class="login-form-text-field"
                           :class="{isTpg:(isTpg || useWhiteTheme)}"
                           v-model="credentials.password"
                           required>
                </div>
                <div>
                    <button class="sign-in-button"
                            v-bind:class="{ 'sign-in-button-disabled': loading,isTpg:isTpg,isTpg:(isTpg || useWhiteTheme) }"
                            @click="submit()"
                            :disabled="loading">
                        {{ submitButtonText }}
                    </button>
                </div>
                <div class="forgot-password-link" :class="{isTpg:(isTpg || useWhiteTheme)}" @click="forgotPassword()" >
                    <a style="cursor:pointer;">
                        Forgot Password
                    </a>
                </div>
            </div>
            </div>
        </div>
        </form>
    </div>
</template>

<script>
const Querystring = require('querystring');

export default {

  data() {
    return {
      csrf: false,
      credentials: {
        email: '',
        password: '',
      },
      error: null,
      loading: false,
      showResetForm: false,
      resetEmail: '',
      success: null,
      noEmailError: 'Please enter a valid email address',
      badLoginError: 'Invalid username or password.  Please try again',
      successfulReset: 'An email with instructions on how to reset your password has been sent to',
      resetError: 'There was a problem sending your password reset email.  Please try again',
    };
  },
  props: ['is-tpg', 'use-white-theme'],
  mounted() {
    this.loading = false;
    this.error = null;

    // Set CSRF Token
    // this.setCSRFCookie();
  },
  methods: {
    setCSRFCookie() {
      this.$http.get('/generate/csrf').then((response) => {
        this.csrf = response.data.data.csrf;
        localStorage.setItem('csrf_token', this.csrf);
      })
        .catch((response) => {
          console.log(`UNABLE TO GET CSRF->${response}`);
        });
    },
    csrfCookie() {
      if (localStorage.getItem('csrf_token') === null || localStorage.getItem('csrf_token') === 'undefined') {
        return false;
      }

      return localStorage.getItem('csrf_token');
    },
    cancelReset() {
      this.showResetForm = false;
      this.resetEmail = '';
      this.error = null;
      this.success = null;
    },
    forgotPassword() {
      this.resetEmail = this.credentials.email;
      this.showResetForm = true;
    },
    handleError() {
      this.error = this.badLoginError;
      this.loading = false;
    },
    sendResetEmail() {
      this.error = null;

      if (!this.resetEmail) {
        this.error = this.noEmailError;
        return;
      }

      const creds = Querystring.stringify({ email: this.resetEmail });
      this.$http.post('/password/email', creds).then(() => {
        this.success = `${this.successfulReset} ${this.resetEmail}`;
        this.resetEmail = '';
      },
      function () {
        this.error = this.resetError;
        this.handleError();
      });
    },
    submit() {
      this.loading = true;
      this.error = null;

      const credentials = Querystring.stringify({
        email: this.credentials.email,
        password: this.credentials.password,
      });

      this.login(credentials);
    },
      formSubmitted() {
      // this.submit();
    },
    login(creds) {
      const self = this;
      this.$http.post('/login', creds).then((response) => {
        // If user already logged in, then reload the pGE
        if (response.data.code == 200 && response.data.message == 'User is already logged in') {
          self.$emit('userLoggedIn', false);
        }

        if (!response.data.data.access_token) {
          self.handleError();
          self.loading = false;

          const params = {
            page_name: 'Login',
            login_success: false,
            errors: response.data.message,
          };
          self.$emit('logEvent', 2, params);
        } else {
          localStorage.setItem('si_access_token_expires_in', response.data.data.expires_in);
          localStorage.setItem('si_access_token', response.data.data.access_token);
          localStorage.setItem('si_refresh_token', response.data.data.refresh_token);
          const { is_demo_signup } = response.data;
          // Emit to MainLayout to check AUTH
          self.$emit('userLoggedIn', is_demo_signup);

          self.loading = false;
          const params = {
            page_name: 'Login',
            login_success: true,
          };
          self.$emit('logEvent', 2, params);
        }
      },
      function (response) {
        this.handleError();
        const params = {
          page_name: 'Login',
          login_success: false,
          errors: response.data.data.message,
        };
        this.$emit('logEvent', 2, params);
      })
        .catch(() => {
          this.handleError();
        });
    },
  },
  computed: {
    submitButtonText() {
      if (this.loading) {
        return 'Checking login ....';
      }
      return 'Sign In';
    },
  },

};

</script>

<style scoped>
    .login-fieldset {
        width: 500px;
        height: 340px;
        margin: 0 auto;
        border-radius: 5px;
        margin-top: 70px;
        opacity: .9;
    }

    .login-alert {
        position: absolute;
        width: 100%;
        top: -200px;
        width: 300px;
        margin: 0 auto;
    }

    .login-form-text-field {
        padding-left: 10px;
    }

    .login-container input[type="email"], .login-container input[type="password"] {
        border: 1px solid #666;
    }

    .login-form-text-field.isTpg {
        border: 1px solid #efefef;
        background: #fff;
        color: #3a3a3a;
    }

    ::-webkit-input-placeholder {
        color: #ccc;
    }

    .login-text {
        font-size: 20px;
        width: 300px;
        text-align: center;
        margin-bottom: 20px;
        font-weight: bold;
    }

    .login-text.isTpg {
        color: #3a3a3a;
    }
    .reset-header {
        text-align:center;
        margin-top:30px;
        margin-bottom:30px;
        color:white;
    }
    .reset-header.isTpg {
        color:black;
    }
    .forgot-password-link.isTpg a{
        color:black;
    }
</style>
